import { ImageToPdfForm } from '@/features/image-to-pdf'
import { ToolPageShell } from '@/shared/seo'

export function HeicVPdfPage() {
  return (
    <ToolPageShell utilityKey="heicVPdf">
      <ImageToPdfForm mode="heic" />
    </ToolPageShell>
  )
}
